<template>
  <b-modal
    :hide-footer="true"
    :title="$t('Pendências e Ocorrências de ' + pessoa)"
    centered
    size="lg"
    id="modal-pendencias"
  >
    <div class="row">
      <div class="col-md-12">
        <table class="table table-striped">
          <tbody v-if="teste">
            <tr v-for="pendencia in pendencias_usuario" :key="pendencia.value">
              <td
                v-html="
                  `<i class='fas fa-exclamation-triangle'></i> ${pendencia.value}`
                "
              ></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  props: ["pendencias", "pessoa"],
  data() {
    return {
      pendencias_usuario: [],
    };
  },
  computed: {
    teste() {
      var i = 0;
      let array = [];
      let pendencias = this.$props.pendencias;
      let configs = this.$parent.item.configs.pendencias_ocorrencias;
      for (var key in pendencias) {
        if (pendencias[key] && key != "usuario_id" && key != "id") {
          for (var config in configs) {
            if (key == configs[config].key) {
              array[i++] = { value: configs[config].value };
            }
          }
        }
      }
      return (this.pendencias_usuario = array);
    },
  },
  methods: {
    submit() {},
  },
};
</script>
